// extracted by mini-css-extract-plugin
export default {"backIcon":"styles__backIcon___XYNF6","back":"styles__back___Mq9Pk"};